/* eslint-disable func-names, max-len, no-underscore-dangle */
$('.see-more-btn, .icon, .icon-video, .icon-download').on('click', function () {
  const elementScrollTarget = `#${$(this).attr('data-slide')}`;
  $('body,html').animate({
    scrollTop: $(elementScrollTarget).offset().top + 1,
  }, 500);
});

$('.see-top-btn').on('click', () => {
  $('body,html').animate({
    scrollTop: '0px',
  }, 1000);
});

$.fn.followTo = function (pos) {
  const $this = this;
  const $window = $(window);

  $window.scroll(() => {
    if ($window.scrollTop() > pos) {
      $this.css({ position: 'absolute', top: pos });
    } else {
      $this.css({ position: 'fixed', top: '70px' });
    }
  });
};

$(window).load(() => {
  const $onekeyPagination = $('#onekey-landing__pagination');
  const $section7 = $('#section-7');

  if ($onekeyPagination.length && $section7.length) {
    $('#onekey-landing__pagination').followTo($('#section-7').position().top + 250);
  }
});
